<script>
import {ref, watch} from "vue";
import useSharedData from "@/use/SharedData.js";
import useSharedMethod from "@/use/SharedMethod";
import axios from "axios";
import useTools from "@/use/Tools";

export default {
    props: {
        workerId: Number,
    },
    setup(props) {
        const {$router} = useTools();
        const {loading} = useSharedData();
        const {transformFilterValues, formatedMonth, formatedDate, priceFormat} = useSharedMethod();
        const paySlips = ref([]);
        
        function findAll() {
            loading.value = true;
            axios.get(`/payments`, {
                params: transformFilterValues({
                    workerId: props.workerId,
                    allRecords: true,
                    sortBy: 'id',
                    descending: true
                })
            }).then((response) => {
                paySlips.value = response.data.elements;
            }).finally(() => {
                loading.value = false;
            });
        }
        
        function view(paySlip) {
            $router.push({name: 'pay_slips.view', params: {id: paySlip.id}});
        }
            
            watch(() => props.workerId, () => {
                if (props.workerId)
                    findAll();
            }, {immediate: true});
            
            return {
                loading,
                paySlips,
                view,
                formatedMonth,
                formatedDate,
                priceFormat
            }
    }
}
</script>

<template>
    <v-simple-table dense fixed-header height="450">
        <template v-slot:default>
            <thead>
            <tr>
                <th class="text-left">{{ $t('common.month') }}</th>
                <th class="text-left">{{ $t('common.label') }}</th>
                <th class="text-left">{{ $t('pay_slip.net_to_pay') }}</th>
                <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(paySlip, index) in paySlips" :key="index">
                <td>
                    {{ formatedMonth(paySlip.annexMonth) }}
                </td>
                <td>
                    {{ paySlip.tagName ? `[${paySlip.tagName}]  ${paySlip.annexName}` : paySlip.annexName }}
                </td>
                <td>
                    {{ priceFormat(paySlip.net) }}
                </td>
                <td>
                    <w-btn-icon
                        icon="mdi-account-credit-card"
                        color="teal"
                        @press="view(paySlip)"
                    />
                </td>
            </tr>
            </tbody>
        </template>
    </v-simple-table>
</template>